<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    @select="v=>$emit('change',v)"
    placeholder="请选择业务类型"
    :clearable="clearable"
    idKey="BusinessTypeId"
    labelKey="BusinessType"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
    params: {
      type: Object,
      default: () => {},
    },
  },
  components: { commonSelect },
  data() {
    return {
      api: require("@/api/ba/businessType").default,
    };
  },
  methods: {
    getDataFunc(params) {
      params = { ...params, ...this.params };
      // console.log("params", params);
      return new Promise((resolve, reject) => {
        this.api.list({ ...params }).then((res) => {
         if(res.Code==0){
          this.$emit("getBusinessTypeId",res.Data[0].BusinessTypeId)
         }
          resolve(res);
        });
      });
    },
  },
};
</script>

